export const SAVE_TO_SHARE_POINT = 'save-to-share-point';
export const SAVE_TO_LOCAL = 'save-to-local';
export const SAVE_AS_FILE = 'save-as-file';
export const SAVE_FILE_BTN_HIDDEN_SLOT = 'save-file-btn-hidden-slot';
export const SAVE_TO_DOWNLOAD = 'download-file-button';
export const SAVE_TO_GOOGLE_DRIVE = 'save-to-google-drive';
export const SAVE_TO_IMANAGE = 'save-to-imanage';
export const SAVE_TO_ONE_DRIVE = 'save-to-one-drive';
export const SAVE_TO_BOX = 'save-to-box';
export const SAVE_TO_DROPBOX = 'save-to-dropbox';
export const SAVE_TO_DRIVES = 'save-to-drives';
export const SAVE_TO_PRIVATE_DRIVE = 'save-to-private-drive';
export const SAVE_TO_PRIVATE_DRIVE_S3 = 'save-to-private-drive-s3';
export const SAVE_TO_PRIVATE_DRIVE_NFS = 'save-to-private-drive-nfs';
export const SAVE_TO_FOXIT_STORAGE = 'save-to-foxit-storage';

export const SAVE_TO_LOCAL_CLASS_TOOLBAR = 'fx-icon-file_save_as-32';
export const SAVE_TO_LOCAL_CLASS = 'fx-icon-file_save_as-16';
export const SAVE_TO_FILE_CLASS = 'fv__icon-toolbar-file-page-save-as';
export const SAVE_TO_FILE_CLASS_TOOLBAR = 'fv__icon-toolbar-file-page-save-as_32';
export const SAVE_TO_GOOGLE_DRIVE_CLASS = 'fv__icon-toolbar-open-google';
export const SAVE_TO_GOOGLE_DRIVE_CLASS_32 = 'fv__icon-toolbar-open-google_32';
export const SAVE_TO_IMANAGE_CLASS = 'fv__icon-toolbar-open-imanage';
export const SAVE_TO_IMANAGE_CLASS_32 = 'fv__icon-toolbar-open-imanage_32';
export const SAVE_TO_ONE_DRIVE_CLASS = 'fv__icon-toolbar-open-one-drive';
export const SAVE_TO_ONE_DRIVE_CLASS_32 = 'fv__icon-toolbar-open-one-drive_32';
export const SAVE_TO_BOX_CLASS = 'fv__icon-toolbar-open-box';
export const SAVE_TO_BOX_CLASS_32 = 'fv__icon-toolbar-open-box_32';
export const SAVE_TO_DROPBOX_CLASS = 'fv__icon-toolbar-open-drop-box';
export const SAVE_TO_DROPBOX_CLASS_32 = 'fv__icon-toolbar-open-drop-box_32';
export const SAVE_TO_DRIVES_CLASS = 'fv__icon-toolbar-save-drives';
export const SAVE_TO_PRIVATE_DRIVE_CLASS = 'fv__icon-toolbar-open-private-drive';
export const SAVE_TO_PRIVATE_DRIVE_S3_CLASS = 'fv__icon-toolbar-open-s3';
export const SAVE_TO_PRIVATE_DRIVE_NFS_CLASS = 'fv__icon-toolbar-open-nfs';
export const SAVE_TO_FOXIT_STORAGE_CLASS = 'fv__icon-toolbar-save-foxit-storage';
export const SAVE_TO_FOXIT_STORAGE_CLASS_32 = 'fv__icon-toolbar-save-foxit-storage_32';

export const SAVE_AS_PDF_A = 'save-as-pdf-a';
export const SAVE_AS_PDF_E = 'save-as-pdf-e';
export const SAVE_AS_PDF_X = 'save-as-pdf-x';

export const File_SIZE_LIMITATION = 4;
